// Public summaries from the owner's Project_Portfolio.pdf.
// Keep source documents, private links and client invoice details out of this bundle.
export const PORTFOLIO_FILTERS = [
  { id: 'all', label: 'All projects' },
  { id: 'web', label: 'Websites & web apps' },
  { id: 'mobile', label: 'Mobile apps' },
  { id: 'business', label: 'Business software' },
  { id: 'ai', label: 'AI & automation' },
];

export const PORTFOLIO_PROJECTS = [
  {
    id: 'retail-scout', title: 'Retail Scout', type: 'Price comparison web app',
    categories: ['web'], icon: 'search', status: 'Completed',
    summary: 'One search. Seventeen UK retailers. A clearer view of DIY, building and trade supply prices.',
    description: 'A UK price comparison tool for DIY, building and trade supplies. Retail Scout searches 17 retailers, including Screwfix, Wickes, B&Q and Toolstation, and presents their results side by side.',
    highlights: ['Compare prices across 17 UK retailers', 'Postcode-based stock and click-and-collect checks', 'Best-price highlights and retailer filters', 'User accounts with light and dark display modes'],
    tags: ['Price comparison', 'Retail search'],
    url: 'https://retail-scout.com', linkLabel: 'Visit website',
  },
  {
    id: 'leos-fleet', title: "Leo’s Fleet", type: 'Fleet management web app',
    categories: ['web', 'business'], icon: 'truck', status: 'Completed',
    summary: 'Vehicle compliance, maintenance reminders and fleet operations, brought together in one system.',
    description: 'A fleet management and compliance system for businesses running vans and lorries. It connects to official DVLA and GOV.UK data for vehicle MOT and tax information.',
    highlights: ['Automatic MOT and tax status checks', 'MOT, tax, service and inspection reminders', 'Lorry inspections and insurance tracking', 'Route planning and PCN management with AI-assisted appeals'],
    tags: ['Fleet operations', 'Compliance'],
    url: 'https://leosfleet.com', linkLabel: 'Visit website',
  },
  {
    id: 'employee-clock', title: 'Employee Clock In / Out App', type: 'Time-tracking application',
    categories: ['mobile', 'business'], icon: 'clock', status: 'Completed',
    summary: 'A straightforward way to record working hours and support everyday workforce management.',
    description: 'A time-tracking application that records when employees start and finish work, providing working-hours data for business administration.',
    highlights: ['Simple employee clock-in and clock-out', 'Working-hours records for each employee', 'Data to support payroll and workforce planning'],
    tags: ['Time tracking', 'Workforce tools'],
  },
  {
    id: 'collaborate-todos', title: 'Collaborate Together Todos', type: 'iOS task management app',
    categories: ['mobile'], icon: 'tasks', status: 'Completed',
    summary: 'Shared tasks, clear deadlines and completion updates for teams, families and everyday life.',
    description: 'A shared task management app for teams, families and individuals. Assign a task to another person with a deadline and follow its progress through to completion. Available on the App Store.',
    highlights: ['Assign tasks to people and set deadlines', 'Attach a screenshot as proof of completion', 'Notify the person who assigned the task', 'Organise work and personal tasks separately'],
    tags: ['iOS', 'Collaboration'],
    url: 'https://apps.apple.com/gb/app/collaborate-together-todos/id6769364877', linkLabel: 'View on App Store',
  },
  {
    id: 'business-website-renewals', title: 'Wheatland Cheese & Leo’s Food', type: 'Business website renewals',
    categories: ['web'], icon: 'globe', status: 'In progress', statusDetail: 'Existing websites completed; upgrades in progress.',
    summary: 'Refreshing two established business websites with new features, interfaces and backend upgrades.',
    description: 'Two completed business websites now being renewed with a refreshed interface, additional features and an upgraded backend.',
    highlights: ['Modernised design and user experience', 'New features within the existing websites', 'Backend rebuild for performance and management'],
    tags: ['Website renewal', 'Backend development'],
  },
  {
    id: 'trade-mind-ai', title: 'Trade Mind AI', type: 'Desktop AI application',
    categories: ['ai', 'business'], icon: 'cpu', status: 'In development',
    summary: 'A business AI assistant being developed around local processing and company-controlled data.',
    description: 'A desktop AI assistant in development for businesses prioritising confidentiality and control. The project is designed around locally operated AI agents and offline processing capabilities.',
    highlights: ['Local AI agent workflows', 'Offline processing capabilities in development', 'Business confidentiality and control as design priorities'],
    tags: ['Local AI', 'Desktop software'],
  },
  {
    id: 'vinted-collector', title: 'Vinted Collector', type: 'Reseller automation web app',
    categories: ['web', 'ai'], icon: 'store', status: 'In development',
    summary: 'Cross-listing and pricing tools designed to connect Vinted inventory with eBay selling.',
    description: 'A cross-listing and pricing tool in development for resellers, connecting Vinted and eBay accounts to simplify listing and inventory workflows.',
    highlights: ['One-click Vinted-to-eBay listing workflow', 'AI-assisted title and description rewriting', 'Configurable profit and promotion percentages', 'Automatic eBay delisting when an item sells on Vinted'],
    tags: ['E-commerce', 'Automation'],
  },
  {
    id: 'ledgerly', title: 'Ledgerly', type: 'Bookkeeping web application',
    categories: ['web', 'business'], icon: 'ledger', status: 'In development',
    summary: 'Income and expenses in one organised place, built with small businesses in mind.',
    description: 'A subscription-based bookkeeping web application in development for small businesses, designed to keep financial activity organised in one place.',
    highlights: ['Business income tracking', 'Expense tracking and financial organisation', 'Subscription-based access for small businesses'],
    tags: ['Bookkeeping', 'Small business'],
  },
  {
    id: 'screwfix-tracker', title: 'Screwfix Tracker', type: 'Purchase price tracking tool',
    categories: ['web', 'ai'], icon: 'chart', status: 'In development',
    summary: 'Monitor purchased items and spot price drops while purchases may still be eligible for return.',
    description: 'A price tracking tool in development for Screwfix purchases. It monitors changing prices and is designed to alert users to reductions within the applicable return window.',
    highlights: ['Track purchased items and price changes', 'Price-drop notifications', 'Return-window awareness, subject to retailer eligibility'],
    tags: ['Price monitoring', 'Retail tools'],
  },
  {
    id: 'royale-property', title: 'Royale Property Man', type: 'Property website redesign',
    categories: ['web'], icon: 'building', status: 'In progress', statusDetail: 'Complete redesign in progress.',
    summary: 'A complete rebuild with a new interface and features for a better customer experience.',
    description: 'A full redesign of the existing Royale Property Man website, rebuilt with a modern interface and additional functionality. The new design is in progress.',
    highlights: ['New website design', 'Additional features and functionality', 'A rebuilt customer experience'],
    tags: ['Property', 'Website redesign'],
    url: 'https://royalepropertyman.com', linkLabel: 'Visit existing website',
  },
];
